const translations = {
    good: 'Good'
};

export default translations;
